import { legendModes } from './consumers.store';

const receivedVsDemandProperty = 'pct_ontvangen_combosleutel_bs6_vs1';
const heatReceivedProperty = 'warmte_ontvangen_combosleutel_bs6_vs1';

export const getFillColorExpression = (legendMode, heatReceivedMaximum = 1000000) => {
  const isHeatReceived = legendMode === legendModes.HEAT_RECEIVED;
  const property = isHeatReceived ? heatReceivedProperty : receivedVsDemandProperty;
  const maximum = isHeatReceived ? heatReceivedMaximum : 1;

  return [
    'interpolate',
    ['linear'],
    ['coalesce', ['get', property], 0],
    0,
    '#fff',
    maximum,
    '#E58C45',
  ];
};

export const layers = {
  gemeente: {
    'id': 'gemeente',
    'type': 'fill',
    'source': 'gemeente',
    'source-layer': 'Gemeente',
    'minzoom': 0,
    'maxzoom': 10,
    'paint': {
      'fill-color': getFillColorExpression(),
      'fill-opacity': 0.8,
    },
  },
  gemeenteOutline: {
    'id': 'gemeente-outline',
    'type': 'line',
    'source': 'gemeente',
    'source-layer': 'Gemeente',
    'minzoom': 0,
    'maxzoom': 10,
    'paint': {
      'line-color': '#fff',
      'line-width': 1.5,
    },
  },
  hoveredGemeente: {
    'id': 'gemeente-hover-outline',
    'type': 'line',
    'source': 'gemeente',
    'source-layer': 'Gemeente',
    'minzoom': 0,
    'maxzoom': 10,
    'paint': {
      'line-color': '#A8D5DE',
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        2,
        0,
      ],
    },
  },
  statSector: {
    'id': 'stat-sector',
    'type': 'fill',
    'source': 'stat-sector',
    'source-layer': 'Stat_sector',
    'minzoom': 10,
    'maxzoom': 16,
    'paint': {
      'fill-color': getFillColorExpression(),
      'fill-opacity': 0.8,
    },
  },
  statSectorOutline: {
    'id': 'stat-sector-outline',
    'type': 'line',
    'source': 'stat-sector',
    'source-layer': 'Stat_sector',
    'minzoom': 10,
    'maxzoom': 16,
    'paint': {
      'line-color': '#fff',
      'line-width': 1.5,
    },
  },
  hoveredStatSector: {
    'id': 'stat-sector-hover-outline',
    'type': 'line',
    'source': 'stat-sector',
    'source-layer': 'Stat_sector',
    'minzoom': 10,
    'maxzoom': 16,
    'paint': {
      'line-color': '#A8D5DE',
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        2,
        0,
      ],
    },
  },
};
